import _ from "lodash";
import * as fb_dbMethods from "@/services/fb_dbMethods";
import * as tagUtils from "@/utils/tagUtils";
import * as convUtils from "@/utils/convUtils";

let sanitizedInpObjForSprGeneration = {
  id: "",
  name: "",
  entityId: "",
  converts_to: [],
  converts_from: [],
  ingredients: [],
  tags: [],
  poss_converts_to: [],
  poss_converts_from: [],
  poss_ingredients: [],
  poss_tags: [],
  pixiData: {},
  column_values: [],
  ndId: "",
  ndType: "",
};

export function parseEntityId(entityId) {
  let spl = entityId.split("_");
  let ret = {
    board_id: spl[1],
    item_id: spl[3],
    version: spl[5],
  };
  return ret;
}

export function getTemplateEntity() {
  return JSON.parse(JSON.stringify(sanitizedInpObjForSprGeneration));
}

export async function setEntity(opts) {
  let { entityId, newEntityState } = opts;
  newEntityState = _.pick(newEntityState, Object.keys(sanitizedInpObjForSprGeneration));
  newEntityState = JSON.parse(JSON.stringify(newEntityState));
  let entity = await fb_dbMethods.writeEntity({ entityId, newEntityState });
  return entity;
}

export async function getEntity(opts) {
  let { entityId } = opts;
  let entity = await fb_dbMethods.getEntity({ entityId });
  return entity;
}

export async function delEntity(opts) {
  let { entityId } = opts;
  let deletedEntity = await fb_dbMethods.delEntity({ entityId });
  return deletedEntity;
}

export async function performChecksAndUpdateLocalFn({ currItem, itemWithUpdates }) {
  let mergedTempObjForThisMethod = { ...currItem, ...itemWithUpdates };
  
  let bkp_entity = getTemplateEntity();
  let freshPixiData = tagUtils.generatePixiData_ItemNode(mergedTempObjForThisMethod);
  
  let commonKeysObjA = {};
  let commonKeysObjB = {};
  for(let k of Object.keys(itemWithUpdates)) {
    if (currItem.hasOwnProperty(k)) {
      commonKeysObjA[k] = JSON.parse(JSON.stringify(itemWithUpdates[k]));
      commonKeysObjB[k] = JSON.parse(JSON.stringify(currItem[k]));
    }
  }
  let needsConvRegen = !_.isEqual(commonKeysObjA, commonKeysObjB);
  if (needsConvRegen) {
    let freshConvData = await convUtils.getPossConversionData(itemWithUpdates);
    mergedTempObjForThisMethod = { ...mergedTempObjForThisMethod, ...freshConvData };
  }

  let updEntityForSync = {
    ...bkp_entity,
    pixiData: freshPixiData,
    ...mergedTempObjForThisMethod
   };

  return updEntityForSync;
}